















import { Vue, Prop, Component } from 'vue-property-decorator';
import FormatParameterTypeService from '../../../services/FormatParameterTypeService';

@Component
export default class FormatParameterTypeSelector extends Vue {
  name = 'format-parameter-type-selector';

  // Making v-model avaiable
  @Prop(String) value: string;

  updateValue(value) {
    this.$emit('input', value)
  }

  formatParameterTypes: Array<string> = new Array<string>();
  
  async created() {
    // Populate the selectbox
    const response = await FormatParameterTypeService.getFormatParameterTypes();
    if (response.status === 200 && response.data) {
      this.formatParameterTypes = [...response.data];
    }
  }
}
